<template>
  <b-container class="cartItemCard">
    <div class="d-md-flex justify-content-between">
      <div class="d-flex">
        <ScanTraderAvatar v-if="!isMobile" class="mr-2" width="60" height="60" :src="channel.account.avatar" />
        <span class="cartItemCard__basic-info">
          <span class="st_heading-medium-big st-md_heading-medium-biggest text-break mb-2">
            {{ channel.title }}
          </span>
          <div class="d-flex flex-md-column flex-wrap align-items-center align-items-md-start justify-content-between justify-content-md-start mt-2 mt-md-0 text-break">
            <span class="st_heading-light-small st-md_heading-light-big mr-3 mr-md-0 mb-md-4">
              {{ channel.account.name.nick }}{{ (channel.account.belongOrg && _.get(channel.account, 'name.real', '')) ? `．${channel.account.name.real || ''}` : '' }}
            </span>
            <span class="mt-md-1 st_none-medium-base st-md_none-medium-big">
              <span class="st_color_sub">${{ channel.price.toLocaleString() }}</span>
              <span class="st_color_gray st_none-none-small st-md_none-none-base">/每{{ channel.unitWord || renewalText }}</span>
            </span>
          </div>
        </span>
      </div>
      <div class="d-flex justify-content-center justify-content-md-start flex-row-reverse flex-md-column mt-5 mt-md-0">
        <b-button class="cartItemCard__btn cartItemCard__btn--first st_sub_l" variant="none" @click.prevent="$root.$emit('bv::show::modal', `modal-${channel.identity}`)">
          服務介紹
        </b-button>
        <b-button class="cartItemCard__btn st_sub_l" variant="none" :to="$userRoute({ name:'u-uid-service', query: { channels: null } })">
          更換方案
        </b-button>
      </div>
    </div>
    <ChannelSimpleDetailModal :channel="channel" />
  </b-container>
</template>

<script>
  import ChannelSimpleDetailModal from '~/components/modal/ChannelSimpleDetailModal'

  export default {
    components: {
      ChannelSimpleDetailModal,
    },
    props: {
      channel: {
        type:     Object,
        required: true,
      },
    },
    computed: {
      renewalText () {
        let text = '月'
        if (!this.channel.convertAutoRenewalToSingle) {
          switch (this.channel.autoRenewal) {
            case 3:
              text = '季'
              break
            case 6:
              text = '半年'
              break
            case 12:
              text = '年'
              break
            case -1:
              text = '次'
              break
          }
        }
        return text
      },
      isMobile () {
        return this.windowWidth < 768
      },
    },
  }
</script>

<style lang="scss" scoped>
  .cartItemCard {
    max-width: 800px;
    margin: 0 auto;
    padding: 26px 14px 20px 24px;

    @include media-breakpoint-up(md) {
      padding: 70px 36px 54px 36px;
    }

    &__btn {
      min-width: 150px;

      @include media-breakpoint-up(md) {
        min-width: 175px;
      }

      &--first {
        margin: 0 0 0 15px;

        @include media-breakpoint-up(md) {
          margin: 0 0 20px 0;
        }
      }
    }

    &__basic-info {
      border-left: 4px solid $st_color_sub_light;
      padding: 0 0 0 10px;
      flex: 1;

      @include media-breakpoint-up(md) {
        display: flex;
        flex-direction: column;
        margin: 0 40px 0 24px;
        border-left: none;
        padding: 0;
        flex: auto;
      }
    }
  }
</style>
